import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-clapperboard-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">欧美三级</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100/80">
              欧美三级是一个专注欧美限制级剧情与文艺影视作品的资源与资讯平台，提供影片分类浏览、剧情介绍、观看指南与最新影视动态，帮助你更便捷地发现与了解优秀的欧美影视内容。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">网站导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="cursor-pointer text-primary-100/80 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="cursor-pointer text-primary-100/80 transition-colors hover:text-accent-300">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/news" className="cursor-pointer text-primary-100/80 transition-colors hover:text-accent-300">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-primary-100/80 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold tracking-wide text-background-50">联系与反馈</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-100/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-300"></i>
                <span>contact@oumeisanji-demo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-feedback-line text-base text-accent-300"></i>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-accent-300">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 rounded-md border border-primary-700/60 bg-primary-800/40 p-4 text-xs leading-relaxed text-primary-100/70">
          <p>
            <strong className="text-background-50">免责声明：</strong>
            本站为内容资讯展示平台，所有影片资料与图文内容均为演示用途的虚构示例，不提供任何影片的在线播放、下载或付费服务。站内信息仅供影视爱好者交流参考，请遵守当地法律法规，支持正版影视发行。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-primary-700/60 pt-6 text-xs text-primary-100/60 sm:flex-row sm:items-center">
          <p>© {year} 欧美三级 · 欧美三级电影资源与资讯平台 版权所有</p>
          <p>内容演示用途 · 请以官方发行信息为准</p>
        </div>
      </div>
    </footer>
  );
}